import fetchData from './Fetch';
import { postData } from './Post';
import { deleteData } from './Delete';

// Étalonnage d'une sonde de température : correction courante + relevés BRUTS
// récents. Les relevés servent à comparer deux mesures simultanées (celle de la
// sonde, celle du thermomètre du client) plutôt que deux mesures proches.
export const getDeviceCalibration = async (devEui, hours = 24) => {
  return await fetchData(`/devices/${devEui}/calibration?hours=${hours}`);
};

// offset en °C, borné à ±5 côté backend.
export const setDeviceCalibration = async (devEui, offset) => {
  return await postData(`/devices/${devEui}/calibration`, { offset });
};

// Retire l'étalonnage : l'affichage revient aux valeurs brutes du capteur.
export const resetDeviceCalibration = async (devEui) => {
  return await deleteData(`/devices/${devEui}/calibration`);
};
